import { render } from "./carousel-v2.vue?vue&type=template&id=15544b78"
import script from "./carousel-v2.vue?vue&type=script&lang=js"
export * from "./carousel-v2.vue?vue&type=script&lang=js"

import "./carousel-v2.vue?vue&type=style&index=0&id=15544b78&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__